module.exports = __webpack_public_path__ + "img/icon-move.390b5d6b.svg";